// Auto-generated by semantic-release - DO NOT EDIT
export const VERSION_INFO = {
  version: '1.10.8',
  buildDate: '2026-10-24T23:31:40.512Z',
  commitSha: 'de8a20a',
} as const

export type VersionInfo = typeof VERSION_INFO
